import React, { ElementType } from 'react';
import { useFeatureToggle } from './hooks';

export type ToggleFeatureReturnType = JSX.Element | null;

export interface ToggleFeatureProps {
  children:
    | ToggleFeatureReturnType
    | (({
        isFeatureEnabled,
      }: {
        isFeatureEnabled: boolean;
      }) => ToggleFeatureReturnType);
  flag: string;
  untoggledComponent?: ElementType;
}

function ToggleFeature({
  children,
  flag,
  untoggledComponent: UntoggledComponent = () => null,
}: ToggleFeatureProps): ToggleFeatureReturnType {
  const isFeatureEnabled = useFeatureToggle(flag);

  if (typeof children === 'function') {
    return children({ isFeatureEnabled });
  }

  return isFeatureEnabled ? children : <UntoggledComponent />;
}

export { ToggleFeature };
